import { combineReducers } from 'redux';
import {
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS,
  SETTING_PAYMENT_METHODS_SET_OUTLET_STATUS,
  SETTING_PAYMENT_METHODS_SET_OUTLETS,
  SETTING_PAYMENT_METHODS_SET_SHOW_OUTLET_DETAIL_MODAL,
  SETTING_PAYMENT_METHODS_SET_SHOW_BANK_STATUS_MODAL,
  SETTING_PAYMENT_METHODS_IS_SHOW_PAYMENT_LIST,
  SETTING_PAYMENT_METHODS_IS_SHOW_REGISTRATION_FORM,
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHOD_KEY,
  SETTING_PAYMENT_METHODS_SET_OPEN_REGISTRATION_OUTLET_MODAL,
  SETTING_PAYMENT_METHODS_SET_ACCORDION_ACTIVE_KEY,
  SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DATA,
  SETTING_PAYMENT_METHODS_SET_OPEN_TERMS_AND_CONDITIONS_MODAL,
  SETTING_PAYMENT_METHODS_SET_OPEN_INFORMATION_MODAL,
  SETTING_PAYMENT_METHODS_SET_BANK_LIST,
  SETTING_PAYMENT_METHODS_SET_BUSINESS_BANK_ACCOUNT_LIST,
  SETTING_PAYMENT_METHODS_SET_SHOW_BANK_ACCOUNT_MODAL_FORM,
  SETTING_PAYMENT_METHODS_SET_SELECTED_PAYMENT_METHOD_LIST,
  SETTING_PAYMENT_METHODS_ADD_ASSIGN_OUTLET,
  SETTING_PAYMENT_METHODS_SHOW_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
  SETTING_PAYMENT_METHODS_HIDE_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION,
  SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DETAIL,
  SETTING_PAYMENT_METHODS_SET_ASSIGNED_OUTLETS,
  SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS_OUTLET,
  SETTING_PAYMENT_METHODS_SET_UNLINK_OUTLETS,
  SET_HAS_ACTIVATE_EWALLET,
  SETTING_PAYMENT_METHODS_SET_OPEN_MDR_MODAL,
  SETTING_PAYMENT_METHODS_SET_MDR_PAYMENT_METHOD,
  SETTING_PAYMENT_METHODS_SET_WALLET_REGISTRATION_STATUS,
  SETTING_PAYMENT_METHODS_SET_KTB_STATUS,
} from 'actions/setting/paymentMethod/constants';

import createReducer from 'utils/createReducer';

const accordionActiveKey = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_ACCORDION_ACTIVE_KEY]: (draft, { payload }) =>
    payload.activeAccordionKey,
});

const activatePaymentStatus = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_WALLET_REGISTRATION_STATUS]: (
    draft,
    { payload }
  ) => payload.status,
});

const assignedOutlets = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_ASSIGNED_OUTLETS]: (draft, { payload }) =>
    payload.assignedOutlets,
});

const bankAccountData = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DATA]: (draft, { payload }) =>
    payload.bankAccountData,
});

const bankAccountDetail = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_BANK_ACCOUNT_DETAIL]: (draft, { payload }) =>
    payload.bankAccountDetail,
});

const bankList = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_BANK_LIST]: (draft, { payload }) =>
    payload.bankList,
});

const businessBankAccountList = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_BUSINESS_BANK_ACCOUNT_LIST]: (
    draft,
    { payload }
  ) => payload.businessBankAccountList,
});

const hasActivatedEwallet = createReducer(true, {
  [SET_HAS_ACTIVATE_EWALLET]: (draft, { payload }) =>
    payload.hasActivatedEwallet,
});

const isShowPaymentList = createReducer(true, {
  [SETTING_PAYMENT_METHODS_IS_SHOW_PAYMENT_LIST]: (draft, { payload }) =>
    payload.isShowPaymentList,
});

const isShowRegistrationForm = createReducer(false, {
  [SETTING_PAYMENT_METHODS_IS_SHOW_REGISTRATION_FORM]: (draft, { payload }) =>
    payload.isShowRegistrationForm,
});

const kybStatus = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_KTB_STATUS]: (draft, { payload }) =>
    payload.status,
});

const mdrPaymentMethod = createReducer(
  {},
  {
    [SETTING_PAYMENT_METHODS_SET_MDR_PAYMENT_METHOD]: (draft, { payload }) =>
      payload.paymentMethod,
  }
);

const menuTitle = createReducer('Payment Method', {});

const openActivateModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_SHOW_OUTLET_DETAIL_MODAL]: (
    draft,
    { payload }
  ) => payload.openOutletDetailModal,
});

const openBankStatusModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_SHOW_BANK_STATUS_MODAL]: (draft, { payload }) =>
    payload.openBankStatusModal,
});

const openInformationModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_OPEN_INFORMATION_MODAL]: (draft, { payload }) =>
    payload.openInfoModal,
});

const openMdrDetailModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_OPEN_MDR_MODAL]: (draft, { payload }) =>
    payload.openMdrDetailModal,
});

const openOutletDetailModal = createReducer(false, {});

const openRegistrationOutletModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_OPEN_REGISTRATION_OUTLET_MODAL]: (
    draft,
    { payload }
  ) => payload.openRegistrationOutletModal,
});

const openTermsAndConditionsModal = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_OPEN_TERMS_AND_CONDITIONS_MODAL]: (
    draft,
    { payload }
  ) => payload.openTermsAndConditionsModal,
});

const outlets = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_OUTLETS]: (draft, { payload }) =>
    payload.outlets,
});

const outletStatus = createReducer(
  {},
  {
    [SETTING_PAYMENT_METHODS_SET_OUTLET_STATUS]: (draft, { payload }) =>
      payload.outletStatus,
  }
);

const paymentMethodKey = createReducer(null, {
  [SETTING_PAYMENT_METHODS_SET_PAYMENT_METHOD_KEY]: (draft, { payload }) =>
    payload.paymentMethodKey,
});

const paymentMethodOutlets = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS_OUTLET]: (draft, { payload }) =>
    payload.paymentMethodOutlets,
});

const paymentMethods = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_PAYMENT_METHODS]: (draft, { payload }) =>
    payload.paymentMethods,
});

const selectedOutlets = createReducer([], {
  [SETTING_PAYMENT_METHODS_ADD_ASSIGN_OUTLET]: (draft, { payload }) =>
    payload.outletList,
});

const selectedPaymentMethodList = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_SELECTED_PAYMENT_METHOD_LIST]: (
    draft,
    { payload }
  ) => payload.selectedPaymentMethodList,
});

const showBankAccountModalForm = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SET_SHOW_BANK_ACCOUNT_MODAL_FORM]: (
    draft,
    { payload }
  ) => payload.showBankAccountModalForm,
});

const showModalAssignOutletsOnRegistration = createReducer(false, {
  [SETTING_PAYMENT_METHODS_SHOW_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION]: () =>
    true,
  [SETTING_PAYMENT_METHODS_HIDE_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION]: () =>
    false,
});

const unlinkOutlets = createReducer([], {
  [SETTING_PAYMENT_METHODS_SET_UNLINK_OUTLETS]: (draft, { payload }) =>
    payload.outletList,

  [SETTING_PAYMENT_METHODS_HIDE_MODAL_ASSIGN_OUTLETS_ON_REGISTRATION]: () => [],
});

export default combineReducers({
  accordionActiveKey,
  activatePaymentStatus,
  assignedOutlets,
  bankAccountData,
  bankAccountDetail,
  bankList,
  businessBankAccountList,
  hasActivatedEwallet,
  isShowPaymentList,
  isShowRegistrationForm,
  kybStatus,
  mdrPaymentMethod,
  menuTitle,
  openActivateModal,
  openBankStatusModal,
  openInformationModal,
  openMdrDetailModal,
  openOutletDetailModal,
  openRegistrationOutletModal,
  openTermsAndConditionsModal,
  outlets,
  outletStatus,
  paymentMethodKey,
  paymentMethodOutlets,
  paymentMethods,
  selectedOutlets,
  selectedPaymentMethodList,
  showBankAccountModalForm,
  showModalAssignOutletsOnRegistration,
  unlinkOutlets,
});
